module.exports = __webpack_public_path__ + "static/media/29BDOS28.f43a42b2.jpg";